import React from "react";
import { useFormikContext } from "formik";
import { Input } from "reactstrap";
import AppFormError from "./AppFormError";
import AppFormLabel from "./AppFormLabel";
import * as _ from "lodash";

interface AppTextInputProps {
  name: string;
  label?: string;
  required?: boolean;
  callback?: (data?: string) => void
  [x: string]: any;
}

function AppTextInput({
  name,
  label,
  required = false,
  callback,
  ...otherProps
}: AppTextInputProps) {
  const { setFieldTouched, setFieldValue, values, errors, touched } =
    useFormikContext();

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (callback) {
      callback(event.target.value)
    }
    setFieldValue(name, event.target.value)
  }

  return (
    <>
      {values && (
        <>
          <AppFormLabel for="floatingInput" label={label} required={required} />

          <Input
            value={Object.byString(values, name)}
            onBlur={() => setFieldTouched(name)}
            onChange={(event) => onChange(event)}
            {...otherProps}
          />
        </>
      )}
      {!values && (
        <>
          <AppFormLabel for="floatingInput" label={label} required={required} />

          <Input
            onBlur={() => setFieldTouched(name)}
            onChange={(event) => onChange(event)}
            {...otherProps}
          />
        </>
      )}
      <AppFormError
        visible={_.get(touched, name)}
        error={_.get(errors, name)}
      />
    </>
  );
}

export default AppTextInput;
